<template>
    <div>
        <v-row dense class="justify-center ma-2">
        <v-col cols="12">
            <v-hover v-slot="{ isHovering, props }">
            <v-card v-bind="props">
                <v-img src="../assets/Shop/duvet.jpg" class="align-end pa-6" cover height="200px">
                <v-card-title class="text-h3">Kołdry</v-card-title>
                <v-overlay
                    :model-value="isHovering"
                    contained
                    class="align-center justify-center"
                >
                    <v-btn
                    size="x-large"
                    color="primary"
                    @click="$router.push('/sklep_koldry')"
                    >
                    Sprawdź
                    </v-btn>
                </v-overlay>
                </v-img>
            </v-card>
            </v-hover>
        </v-col>
        <!--<v-col cols="12">
            <v-hover v-slot="{ isHovering, props }">
            <v-card v-bind="props">
                <v-img src="../assets/Shop/pillow.jpg" class="align-end pa-6" cover height="200px">
                <v-card-title class="text-h3">Poduszki</v-card-title>
                <v-overlay
                    :model-value="isHovering"
                    contained
                    class="align-center justify-center"
                >
                    <v-btn
                    size="x-large"
                    color="primary"
                    @click="$router.push('/sklep_poduszki')"
                    >
                    Sprawdź
                    </v-btn>
                </v-overlay>
                </v-img>
            </v-card>
            </v-hover>
        </v-col>-->
        </v-row>
    </div>
</template>
<script></script>